import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import CheckBoxIcon from '@mui/icons-material/CheckBox';

import { PureRender } from 'utils/component-helpers';
import { responseValueToJsx } from 'containers/FormPage/FormResponseOverlay/responseValueToJsx';

const FormResponsesOverlay = ({ toggleAction, formQuestions, formResponse }) =>
  formResponse ? (
    <Dialog open onClose={() => toggleAction(null)} fullWidth maxWidth="md">
      <DialogTitle>
        {`${formResponse.get('user')?.get('name') || 'Anonymous user'}'s response`}
      </DialogTitle>
      <DialogContent>
        {formQuestions.map((question) => {
          const questionResponse = formResponse
            .get('data')
            .find((item) => String(item.get('question')) === String(question.get('_id')));
          if (!questionResponse) {
            return null;
          }
          const questionResponseValue = questionResponse.get('value');
          return (
            <Fragment key={question.get('_id')}>
              {question.get('questionType') !== 'Checkbox' ? (
                <Typography
                  type="headline"
                  component="h3"
                  style={{ fontSize: 15, fontWeight: 500 }}
                >
                  {question.get('title')}
                </Typography>
              ) : null}
              <Typography component="p" style={{ fontSize: 15, fontWeight: 300 }}>
                {question.get('questionType') === 'Checkbox' ? (
                  <CheckBoxIcon style={{ paddingRight: 5 }} />
                ) : null}
                {responseValueToJsx(questionResponseValue, question.get('questionType'))}
              </Typography>
              <br />
            </Fragment>
          );
        })}
      </DialogContent>
      <DialogActions>
        <Button color="primary" onClick={() => toggleAction(null)}>
          Close
        </Button>
      </DialogActions>
    </Dialog>
  ) : null;

FormResponsesOverlay.propTypes = {
  formResponse: PropTypes.object,
  formQuestions: PropTypes.object,
  toggleAction: PropTypes.func,
};

export default PureRender(FormResponsesOverlay);
